import React, { useState } from 'react';
import ListUsers from './ListUsers';
import Rewards from './Rewards';
import PushNotifications from './PushNotifications';
import Announcements from './Announcements';
import Menu from './Menu';
import './AppFeatures.css';

const TABS = [
  { id: 'users', label: 'Users', icon: '👥' },
  { id: 'rewards', label: 'Rewards', icon: '🎁' },
  { id: 'push-notifications', label: 'Push Notifications', icon: '📱' },
  { id: 'announcements', label: 'Announcements', icon: '📢' },
  { id: 'menu', label: 'Menu Manager', icon: '📋' },
];

const AppFeatures = () => {
  const [activeTab, setActiveTab] = useState('users');

  return (
    <div className="app-features">
      <header className="app-features-header">
        <h1>App Management</h1>
      </header>

      <nav className="app-features-nav">
        <div className="app-features-tabs">
          {TABS.map(tab => (
            <button
              key={tab.id}
              className={`app-features-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>
      </nav>

      <main className="app-features-content">
        {activeTab === 'users' && <ListUsers />}
        {activeTab === 'rewards' && <Rewards />}
        {activeTab === 'push-notifications' && <PushNotifications />}
        {activeTab === 'announcements' && <Announcements />}
        {activeTab === 'menu' && <Menu />}
      </main>
    </div>
  );
};

export default AppFeatures;
